import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'nwt-power-supply-move-error-dialog',
  template:
  `
    <strong> {{ message }} </strong>
    <mat-dialog-actions class = "d-flex justify-content-center">
      <button mat-button type = "button" (click) = "onClickOK()">OK</button>
    </mat-dialog-actions>
  `
})
export class PowerSupplyMoveErrorDialog {
  public message: string = '';

  public constructor(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(MAT_DIALOG_DATA) private data: any, // TODO: Create interface
    public dialogRef: MatDialogRef<PowerSupplyMoveErrorDialog>
  ) {
      this.message = this.data.message;
  }

  public onClickOK(): void {
    this.dialogRef.close();
  }
}
